import { render } from "./ProfileInfoView.vue?vue&type=template&id=4dffdd89&ts=true"
import script from "./ProfileInfoView.vue?vue&type=script&lang=ts"
export * from "./ProfileInfoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__